import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatchPreviewViewModel, SelectionToggleRequest } from '../sportsbook/sportsbook.models';
import { OddsValueFlashDirective } from '../shared/odds-value-flash.directive';

@Component({
  selector: 'app-match-preview',
  standalone: true,
  imports: [CommonModule, TranslateModule, OddsValueFlashDirective],
  templateUrl: './match-preview.component.html',
  styleUrl: './match-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatchPreviewComponent {
  readonly match = input.required<MatchPreviewViewModel>();
  readonly quickGroupIds = input<readonly string[] | null>(null);

  readonly selectionToggle = output<SelectionToggleRequest>();
  readonly openDetail = output<number>();

  protected readonly visibleQuickSelections = computed(() => {
    const quickGroupIds = this.quickGroupIds();
    return quickGroupIds === null
      ? this.match().quickSelections
      : this.match().quickSelections.filter(selection => quickGroupIds.includes(selection.quickGroupId));
  });

  protected onSelectionClick(selection: MatchPreviewViewModel['quickSelections'][number]): void {
    if (selection.betTypeId === null || selection.oddId === null) {
      return;
    }

    this.selectionToggle.emit({
      matchId: this.match().id,
      betTypeId: selection.betTypeId,
      oddId: selection.oddId
    });
  }
}
